















































































import { Component, Vue } from 'vue-property-decorator';
import FieldWrapper from '@shared/components/forms/inputs/field-wrapper/field-wrapper.vue';
import { ContactRelationsMigrationMapping } from '@core/interfaces/contact-relations-migration-mapping';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import { superadmin_options } from '@/config/superadmin_options';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faForward, faPlus, faTrash, faUndo } from '@fortawesome/free-solid-svg-icons';

library.add(faPlus, faForward, faUndo, faTrash);

@Component({
  name: 'bpc-superadmin-contact-relations-migration-settings',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-entity-select': EntitySelect,
    'bpc-select': Select,
  },
})
export default class SuperadminContactRelationsMigrationSettings extends Vue {
  mounted() {
    this.fetchMappings();
  }

  // DATA
  public mappings: ContactRelationsMigrationMapping[] = [];
  public disabled: boolean = false;
  public saving: boolean = false;
  public running: boolean = false;
  public dirty: boolean = false;

  get fieldsConfig() {
    return superadmin_options;
  }

  get isDirty() {
    console.log('DIRTY : ' + this.dirty);
    return this.dirty;
  }

  // METHODS
  addMapping() {
    console.log('ADD MAPPING');
    const newMapping: ContactRelationsMigrationMapping = {
      id: null,
      contactRelationCategoryId: null,
      type: null,
      status: 'todo',
    };
    this.mappings.push(newMapping);
    this.dirty = true;
  }

  removeMapping(index: number) {
    console.log('REMOVE MAPPING');
    this.mappings.splice(index, 1);
    this.dirty = true;
  }

  fetchMappings() {
    const basePath = this.$bpcApiRouteHelper.getApiPath('contact-relations-migration');
    this.$bpcApi
      .get(basePath + '/settings')
      .toPromise()
      .then(response => {
        this.mappings = response.data;
        if (this.mappings.length === 0) {
          this.addMapping();
        }
      })
      .catch(error => {
        this.$bpcMessage.showErrorMessage({ text: error.message });
      });
  }

  saveMappings() {
    this.saving = true;
    const basePath = this.$bpcApiRouteHelper.getApiPath('contact-relations-migration');
    this.$bpcApi
      .post(basePath + '/settings', {
        settings: this.mappings,
      })
      .toPromise()
      .then(response => {
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
        this.mappings = response.data;
        this.saving = false;
        this.dirty = false;
      })
      .catch(error => {
        this.saving = false;
        this.$bpcMessage.showErrorMessage({ text: error.message });
      });
  }

  runMigration() {
    this.running = true;
    const basePath = this.$bpcApiRouteHelper.getApiPath('contact-relations-migration');
    this.$bpcApi
      .post(basePath + '/run', {})
      .toPromise()
      .then(() => {
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
      })
      .catch(error => {
        this.running = false;
        this.$bpcMessage.showErrorMessage({ text: error.message });
      });
  }

  resetMigration() {
    this.running = true;
    const basePath = this.$bpcApiRouteHelper.getApiPath('contact-relations-migration');
    this.$bpcApi
      .post(basePath + '/reset', {})
      .toPromise()
      .then(() => {
        this.running = false;
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
      })
      .then(() => {
        this.fetchMappings();
      })
      .catch(error => {
        this.running = false;
        this.$bpcMessage.showErrorMessage({ text: error.message });
      });
  }
}
